import art1 from '../images/art/r1.jpg';
import art2 from '../images/art/r2.jpg';
import art3 from '../images/art/r3.jpg';
import art4 from '../images/art/r4.jpg';
import art5 from '../images/art/s1.jpg';
import art6 from '../images/art/s2.jpg';
import art8 from '../images/art/p1.jpg';
import art7 from '../images/art/p2.png';
import art9 from '../images/art/p3.jpg';
import art10 from '../images/art/ww1.png';
import art11 from '../images/art/ww2.jpg';
import art12 from '../images/art/x1.jpg';
import art13 from '../images/art/d1.png';
import art14 from '../images/art/b1.png';
import art15 from '../images/art/b2.png';
import art16 from '../images/art/b3.jpg';
import art17 from '../images/art/h1.jpg';
import art18 from '../images/art/h2.jpg';
import art19 from '../images/art/d1.jpg';
import art20 from '../images/art/d2.jpg';
import art21 from '../images/art/d3.jpg';

const art_project = {
  title: 'Artwork',
  description: 'Check out some more of my work including 3D modeling with Maya, Photoshop, woodworking, pottery, and doodles.',

  sections: [
    {
      subheading: '',
      paragraph: [],
      image: [],
    },
  ],
  imgWtitle: [
    {
      title: "3D Modeling with Maya",
      bio: "spatial and abstract modeling projects",
      photos: [
        {
          src: art1,
          width: 1.5,
          height: 1.0,
        }, {
          src: art2,
          width: 1.5,
          height: 1.0,
        }, {
          src: art3,
          width: 1.5,
          height: 1.0,
        }, {
          src: art4,
          width: 1.5,
          height: 1.0,
        }, {
          src: art5,
          width: 1.0,
          height: 1.0,
        }, {
          src: art6,
          width: 1.6,
          height: 1.0,
        },
      ],
    },
    {
      title: "Photoshop",
      bio: "a website design and a couple posters from a digital design class",
      photos: [
        {
          src: art7,
          width: 1.0,
          height: 1.4,
        }, {
          src: art8,
          width: 1.0,
          height: 2.8,
        }, {
          src: art9,
          width: 1.0,
          height: 1.3,
        },
      ],
    },
    {
      title: "Woodworking",
      bio: "some string art, a bench and a xylophone",
      photos: [
        {
          src: art10,
          width: 1.0,
          height: 1.0,
        }, {
          src: art11,
          width: 1.0,
          height: 1.0,
        }, {
          src: art12,
          width: 1.0,
          height: 1.1,
        }, {
          src: art13,
          width: 2.2,
          height: 1.0,
        }, {
          src: art14,
          width: 1.3,
          height: 1.0,
        }, {
          src: art15,
          width: 1.0,
          height: 1.0,
        }, {
          src: art16,
          width: 1.3,
          height: 1.0,
        },
      ],
    },
  ],
  reRenderedIMG: [
    {
      title: "Pottery",
      bio: "a ring holder",
      photos: [
        {
          src: art17,
        }, {
          src: art18,
        },
      ],
    },
    {
      title: "Doodles",
      bio: "stuff I've drawn when I'm bored",
      photos: [
        {
          src: art19,
        }, {
          src: art20,
        }, {
          src: art21,
        },
      ],
    },
  ]
};

export default art_project;